export default function RoleListTable() {
  return (
    <div className="ad-card ad-card-lg ad-animate">

      {/* Header */}
      <div className="ad-card-header ad-header-flex">
        <h5 className="ad-card-title">Role List</h5>

        <input
          type="text"
          placeholder="Search..."
          className="ad-input ad-input-sm"
        />
      </div>

      {/* Table Section */}
      <div className="ad-table-container">
        <table className="ad-table">
          <thead>
            <tr>
              <th>Company</th>
              <th>Role Name</th>
              <th>Created Date</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td colSpan="4" className="ad-empty-state">
                No Data Found
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
}